/* German presentation for Geos labels which the app's translation editor does not expose.
   Region codes, currency codes, destinations and selection handlers remain app-owned. */
(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('de')) return;
  const words = new Map([
    ['Close', 'Schließen'], ['Search your country', 'Land suchen'],
    ['Search your language', 'Sprache suchen'], ['Preferred language', 'Bevorzugte Sprache'],
    ['Select your country', 'Land auswählen'], ['Apply', 'Übernehmen'],
    ['Country', 'Lieferland'], ['Language', 'Sprache'], ['Currency', 'Währung'],
    ['No results found', 'Keine Treffer']
  ]);
  const names = new Map();
  if (typeof Intl.DisplayNames === 'function') {
    const en = new Intl.DisplayNames(['en'], { type: 'region' });
    const de = new Intl.DisplayNames(['de'], { type: 'region' });
    ['BE','NL','LU','DE','AT','CZ','DK','ES','FR','IT','PL','PT','SE','FI','SI','IE','NO','GB','CH'].forEach(code => names.set(en.of(code), de.of(code)));
  }
  function translate(value) {
    const text = value.trim();
    let translated = words.get(text);
    if (!translated) {
      for (const [en, de] of names) {
        if (text === en || text.startsWith(en + ' (') || text.toLowerCase() === (en + ' flag').toLowerCase()) {
          translated = de + text.slice(en.length).replace(/ flag$/i, ' Flagge');
          break;
        }
      }
    }
    return translated ? value.replace(text, translated) : value;
  }
  let queued = false;
  const observer = new MutationObserver(records => {
    const relevant = records.some(record => {
      const target = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
      return target?.closest('[id^="gls-"]') || [...record.addedNodes].some(node => node.nodeType === Node.ELEMENT_NODE && (node.id?.startsWith('gls-') || node.querySelector('[id^="gls-"]')));
    });
    if (relevant && !queued) { queued = true; requestAnimationFrame(update); }
  });
  function update() {
    queued = false; observer.disconnect();
    document.querySelectorAll('[id^="gls-"]').forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement?.closest('script,style')) continue;
        const value = translate(node.nodeValue);
        if (value !== node.nodeValue) node.nodeValue = value;
      }
      [root, ...root.querySelectorAll('[placeholder],[aria-label],[alt],[data-name]')].forEach(el => {
        ['placeholder','aria-label','alt','data-name'].forEach(attr => {
          const value = el.getAttribute(attr);
          if (value != null) { const translated = translate(value); if (translated !== value) el.setAttribute(attr, translated); }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
})();
